import * as React from "react"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import { X } from "lucide-react"

import { cn } from "../../lib/utils"

const DialogPDF = DialogPrimitive.Root

const DialogTriggerPDF = DialogPrimitive.Trigger

const DialogPortalPDF = DialogPrimitive.Portal

const DialogClosePDF = DialogPrimitive.Close

const DialogOverlayPDF = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn(
      "fixed inset-0 z-50 bg-black/30  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    )}
    {...props} />
))
DialogOverlayPDF.displayName = DialogPrimitive.Overlay.displayName

const DialogContentPDF = React.forwardRef(({ className, children, ...props }, ref) => (
  <DialogPortalPDF>
    <DialogOverlayPDF />
    <DialogPrimitive.Content
      ref={ref}
      // className={cn(
      //   "fixed left-[50%] top-[50%] max-h-[300px] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] md:rounded-lg rounded-lg",
      //   className
      // )}
       className={cn(
          "fixed left-1/2 top-1/2 z-50",

          // ✅ Full responsive width
          "w-[100vw] sm:w-[95vw] md:max-w-[40rem]",

          // ✅ Height fix (NO CUT ISSUE)
          "max-h-[100vh] sm:max-h-[90vh]",

          // ✅ Center align
          "translate-x-[-50%] translate-y-[-50%]",

          // ✅ IMPORTANT: flex layout (not grid)
          "flex flex-col overflow-hidden",

          // ✅ UI
          "bg-white border shadow-lg",
          "rounded-none sm:rounded-lg",

          // ✅ Padding fix
          "p-2 sm:p-4",

          className
        )}
      {...props}>
      {children}
      <DialogPrimitive.Close
        className="absolute right-3 top-3 z-50 bg-white rounded-full p-1 shadow">
        <X className="h-4 w-4" />
        <span className="sr-only">Close</span>
      </DialogPrimitive.Close>
    </DialogPrimitive.Content>
  </DialogPortalPDF>
))
DialogContentPDF.displayName = DialogPrimitive.Content.displayName

const DialogHeaderPDF = ({
  className,
  ...props
}) => (
  <div
    className={cn("flex flex-col space-y-1.5 text-center sm:text-left overflow-hidden", className)}
    {...props} />
)
DialogHeaderPDF.displayName = "DialogHeader"

const DialogFooterPDF = ({
  className,
  ...props
}) => (
  <div
    className={cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className)}
    {...props} />
)
DialogFooterPDF.displayName = "DialogFooter"

const DialogTitlePDF = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Title
    ref={ref}
    className={cn("text-lg font-semibold leading-none tracking-tight relative",
  "-right-4 -bottom-2",           // mobile: small offset
  "sm:-right-8 sm:-bottom-3",     // tablet: moderate offset
  "md:-right-[120px] md:-bottom-[20px]", className)}
    {...props} />
))
DialogTitlePDF.displayName = DialogPrimitive.Title.displayName

const DialogDescriptionPDF = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Description
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props} />
))
DialogDescriptionPDF.displayName = DialogPrimitive.Description.displayName

export {
  DialogPDF,
  DialogPortalPDF,
  DialogOverlayPDF,
  DialogClosePDF,
  DialogTriggerPDF,
  DialogContentPDF,
  DialogHeaderPDF,
  DialogFooterPDF,
  DialogTitlePDF,
  DialogDescriptionPDF,
}
